import { setPreferVisitor } from '../../../react/features/base/connection/actions.any';
import { DEFAULT_SERVER_URL } from '../../../react/features/base/settings/constants';
import { iAmVisitor } from '../../../react/features/visitors/functions';
import { hideSpeakerDialog, openWaitForSpeakerDialog } from './actions.any';
import { API_JOIN_URL, WAITING_FOR_SPEAKER_TIMEOUT } from './constants';
export function getUserDataBySystem(state) {
    if (navigator.product === 'ReactNative') {
        // @ts-ignore
        const { userId, conferenceId, staticWebinarData } = state['features/base/config'] || {};
        return {
            roomToken: conferenceId,
            websocketUser: userId,
            staticWebinarData
        };
    }
    // @ts-ignore
    const { roomToken, websocketUser, staticWebinarData } = state['features/base/config'] || {};
    return {
        roomToken,
        websocketUser,
        staticWebinarData
    };
}
export function isWebinarEnabledInRoom(state) {
    const { staticWebinarData } = getUserDataBySystem(state);
    return Boolean(staticWebinarData);
}
export function getWebinarSpeakersList(state) {
    const { staticWebinarData } = getUserDataBySystem(state);
    return staticWebinarData?.speakers;
}
export function isRaiseHandAllowed(state) {
    const { staticWebinarData } = getUserDataBySystem(state);
    if (!isWebinarEnabledInRoom(state)) {
        return true;
    }
    return staticWebinarData?.isRaiseHandAllowed;
}
export function isUserByIdSpeaker(state) {
    if (!isWebinarEnabledInRoom(state)) {
        return false;
    }
    // @ts-ignore
    const { websocketUser } = getUserDataBySystem(state);
    return Boolean(getWebinarSpeakersList(state)?.[websocketUser]);
}
function fetchData(state) {
    // @ts-ignore
    const { roomToken, websocketUser } = getUserDataBySystem(state);
    const fetchUrl = `${DEFAULT_SERVER_URL}${API_JOIN_URL}`;
    const queryParams = new URLSearchParams({
        'roomToken': roomToken,
        'userId': websocketUser
    });
    return fetch(`${fetchUrl}${queryParams}`);
}
let RESPONSE_STATUS = 0;
export async function checkIfUserCanJoin(state, dispatch) {
    try {
        if (!isUserByIdSpeaker(state) && !iAmVisitor(state)) {
            dispatch(setPreferVisitor(true));
        }
        if (navigator.product !== 'ReactNative' && RESPONSE_STATUS === 200) {
            return Promise.resolve(RESPONSE_STATUS);
        }
        const response = await fetchData(state);
        switch (response?.status) {
            case 200: {
                RESPONSE_STATUS = response?.status;
                return Promise.resolve(response);
            }
            case 409: {
                const intervalPromise = new Promise(resolveTimer => {
                    const intervalId = setInterval(() => {
                        fetchData(state).then(responseLoop => {
                            if (responseLoop?.status === 200) {
                                RESPONSE_STATUS = responseLoop?.status;
                                clearInterval(intervalId);
                                dispatch(hideSpeakerDialog());
                                resolveTimer(intervalId);
                            }
                        });
                    }, WAITING_FOR_SPEAKER_TIMEOUT);
                    dispatch(openWaitForSpeakerDialog({ waitForSpeakerTimeoutID: intervalId }));
                });
                await intervalPromise;
                break;
            }
            default:
                return Promise.reject(response?.statusText);
        }
    }
    catch (e) {
        console.error(e, 'catch11');
    }
}
export function isMetaWebinarWasSend(state) {
    const { metadata } = state['features/base/conference'] || {};
    // @ts-ignore
    return Boolean(metadata?.wildixMetadata?.webinarConfig);
}
